export const INCOMING_MESSAGE_SQUEAK_SOUND_URL2 =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1709680919/Duck_Toy_Squeak_Dog_Toy_Sound_Effect_download_t5d4t5.mp3';
export const INCOMING_MESSAGE_BL_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1712987637/beluga-text_azbviu.mp3';
